<btn
    [id]="id()"
    [severity]="severity()"
    [label]="label()"
    [icon]="hideIcon() ? '' : icon() || 'fa-solid fa-times'"
    [text]="text()"
    [rounded]="rounded()"
    [outlined]="outlined()"
    [loading]="loading()"
    [disabled]="disabled()"
    [class.w-100]="fullWidth()"
    [pTooltip]="tooltip() | translate"
    [tooltipPosition]="tooltipPosition()"
    [tooltipDisabled]="tooltipDisabled()"
    (onClick)="openPopconfirm($event); $event.stopPropagation()"></btn>

<p-confirmpopup [id]="id() + '-popup'" [key]="id() + '-btn'" />
